import { Component, Input } from '@angular/core';

/**
 * Used to work around i18n limitations
 */
@Component({
    selector: '[render-day-of-week-abbr]',
    template: `
@switch (day) {
  @case ('Monday') {
    <ng-container i18n="Day of week short- Mon@@day.of.week.short.mon">
        Mon
      </ng-container>
  }
  @case ('Tuesday') {
    <ng-container i18n="Day of week short- Tue@@day.of.week.short.tue">
        Tue
      </ng-container>
  }
  @case ('Wednesday') {
    <ng-container i18n="Day of week short- Wed@@day.of.week.short.wed">
        Wed
      </ng-container>
  }
  @case ('Thursday') {
    <ng-container i18n="Day of week short- Thu@@day.of.week.short.thu">
        Thu
      </ng-container>
  }
  @case ('Friday') {
    <ng-container i18n="Day of week short- Fri@@day.of.week.short.fri">
        Fri
      </ng-container>
  }
  @case ('Saturday') {
    <ng-container i18n="Day of week short- Sat@@day.of.week.short.sat">
        Sat
      </ng-container>
  }
  @case ('Sunday') {
    <ng-container i18n="Day of week short- Sun@@day.of.week.short.sun">
        Sun
      </ng-container>
  }
}
`,
    standalone: true
})
export class RenderDayOfWeekAbbreviationComponent {
  @Input() day: string;
}
